import React from "react"
import { t } from "../../../i18n"
import { substring, ArrowRightSM } from "../normalizer"
import CustomButton from "../shared/CustomButton"

const months = ["jan.", "fev.", "mar.", "abr.", "mai.", "jun.",
                  "jul.", "ago.", "set.", "out.", "nov.", "dez."]

const QuizzItem = props => {
  const {
    main_image: mainImage,
    name,
    description,
    end_date: endDate,
    done,
    id
  } = props

  const date = new Date(endDate)
  const dateLabel = `${date.getDate()} ${months[date.getMonth()]}`

  const image = mainImage && mainImage.url ? mainImage.url : ""
  const path = done ? `/quiz/history/${id}` : `/quiz/${id}`

  return (
    <div className="promotion-card">
      {image && <img className="promotion-card-image" src={image} alt="" />}
      <div className="promotion-card-container">
        <label className="promotion-card-date">
          {dateLabel}
        </label>
        <label className="promotion-card-header">
          {name}
        </label>
        <div className="promotion-card-content">
          <p className="promotion-card-content-text">{substring(description || "", 120, "...")}</p>
          <CustomButton className="promotion-card-content-link" link tight large to={path}>
            {done ? t('gamification2026.quiz.review') : "Saiba mais"}
            <ArrowRightSM />
          </CustomButton>
        </div>
      </div>
    </div>
  )
}

export default QuizzItem
